import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import './index.scss';

const LoadingSpinner = ({additionalClasses = ''}) => {
    const className = R.concat('fa fa-circle-o-notch fa-spin loading-spinner ', additionalClasses);

    return <i className={className} />;
};

LoadingSpinner.propTypes = {
    additionalClasses: PropTypes.string
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./components/loading_spinner/index.js